export default "__VITE_ASSET__B_F0W9IQ__"